import { memo, useMemo, useState } from "react"
import { connectComponent } from "@tm/morpheus"
import { useLocalization } from "@tm/localization"
import { Box, MenuItem, Select, styled } from "@tm/components"
import { AddressType } from "@bundles/parts/data/model"
import { List } from "@tm/controls"
import { DetailsReferencesState, Actions } from "./business"
import { createAddress } from "./business/helper"
import AddressLine from "./components/AddressLine"

type Props = {
    state: DetailsReferencesState
}

const StyledList = styled(List)(() => ({
    padding: "0.25em",
    "& div.list__item": {
        width: "100%",
        alignItems: "baseline",
        padding: ".5rem .75rem",
        marginCottom: ".25rem",
    },
}))

const DetailsSupplierInfo = memo(({ state }: Props) => {
    const { translateText } = useLocalization()
    const { detailsResponse } = state

    const addressOptions = useMemo(() => {
        const findInfo = (type: AddressType) => detailsResponse?.supplierInfos?.find((x) => x.addressType === type)

        return [
            {
                type: AddressType.general,
                labelKey: 14066,
                addressLines: createAddress(findInfo(AddressType.general), translateText),
            },
            {
                type: AddressType.productSafetyInformation,
                labelKey: 14061,
                addressLines: createAddress(findInfo(AddressType.productSafetyInformation), translateText),
            },
        ]
    }, [detailsResponse])

    const enabledOptions = addressOptions.filter((opt) => opt.addressLines?.length)

    const [selectedAddressType, setSelectedAddressType] = useState<AddressType>(enabledOptions[0]?.type)

    return (
        <Box width="100%" padding="1rem">
            <Select
                defaultValue={selectedAddressType}
                onChange={(selected) => setSelectedAddressType(selected.target.value as AddressType)}
                variant="filled"
                size="medium"
                sx={{ margin: "0 0 1.25em 0.25em" }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                }}
            >
                {addressOptions.map(({ type, labelKey, addressLines }) => (
                    <MenuItem key={type} value={type} disabled={!addressLines?.length}>
                        {translateText(labelKey)}
                    </MenuItem>
                ))}
            </Select>
            <StyledList view={AddressLine} items={addressOptions.find((opt) => opt.type === selectedAddressType)?.addressLines ?? []} />
        </Box>
    )
})

export default connectComponent(Actions, DetailsSupplierInfo)
